import { ofType } from "redux-observable";
import { notifyError, notifySuccess, sendApiRequest } from "../../../actions";
import generateError from "../../../utilities/generateError";
import {
  scoreCardCalculateFulfilled,
  scoreCardCalculatePending,
  scoreCardCalculateRejected,
} from "../actions/scoreCardCalculateActions";
import { SCORE_CARD_CALCULATE } from "../types/scoreCardCalculate";
import { mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";

const createPayload = (payload) => ({
  method: "post",
  url: "scorecard/calculatesingleclient",
  onSuccess: [
    scoreCardCalculateFulfilled,
    () => notifySuccess("Operation successful"),
  ],
  onError: [
    scoreCardCalculateRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const scoreCardCalculateEpic$ = (action$) =>
  action$.pipe(
    ofType(SCORE_CARD_CALCULATE.DEFAULT),
    mergeMap(({ payload }) =>
      merge(
        of(scoreCardCalculatePending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default scoreCardCalculateEpic$;



// WEBPACK FOOTER //
// ./src/features/score-card/epics/scoreCardCalculateEpic.js